import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const StyledModalContainer = styled.div`
  box-sizing: border-box;
  position: relative;
  padding: 60px;
  text-align: center;
  background: ${withVar(DesignToken.SurfacePrimaryDefault)};
`;
